export { default } from './index.vue';


// WEBPACK FOOTER //
// ./packages/dof-overlay/index.js